// Pack cover thumbnail: rounded square, grey placeholder fill, 1px border. Size
// comes from `className` (e.g. "h-[110px] w-[110px]"). `border` picks the edge:
// "default" — the #979797 inset line (auth / buy-flow thumbs); "subtle" — the
// hairline rgba(42,42,42,0.12) used on the cart rows and Browse Packs rail.
export function PackArtwork({
    src,
    alt = '',
    border = 'default',
    className = '',
}: {
    src?: string | null;
    alt?: string;
    border?: 'default' | 'subtle';
    className?: string;
}) {
    return (
        <div
            className={`flex-none overflow-hidden rounded-lg border bg-placeholder ${
                border === 'subtle' ? 'border-hairline' : 'border-placeholder-line'
            } ${className}`}
        >
            {src && <img src={src} alt={alt} className="h-full w-full object-cover" />}
        </div>
    );
}

export default PackArtwork;
